import { Link } from "react-router-dom";
import AnimatedBackground from "../../common/AnimatedBackground";
import Footer from "../Footer/Footer";
import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative w-full min-h-lvh text-white flex flex-col">
      <AnimatedBackground />

      {/* Main content — centrado vertical */}
      <div className="relative flex-1 flex flex-col items-center justify-center text-center px-6 py-20 select-none">
        {/* 404 number */}
        <div className="relative mb-6">
          <span
            className="text-[10rem] sm:text-[14rem] font-bold font-header leading-none text-transparent
              bg-clip-text bg-gradient-to-b from-gray-700 to-gray-800/20"
          >
            404
          </span>
          {/* Subtle green glow behind the number */}
          <span
            aria-hidden
            className="absolute inset-0 flex items-center justify-center text-[10rem] sm:text-[14rem] font-bold font-header leading-none
              text-green-300/5 blur-2xl pointer-events-none"
          >
            404
          </span>
        </div>

        {/* Message */}
        <h1 className="text-xl sm:text-2xl font-semibold font-header text-white mb-2">
          Página no encontrada
        </h1>
        <p className="text-gray-500 text-sm max-w-xs leading-relaxed mb-10">
          La URL que buscás no existe o fue movida. Volvé al inicio desde acá.
        </p>

        {/* CTAs */}
        <div className="flex gap-3 flex-wrap justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium
              bg-green-300/10 border border-green-300/40 text-green-300
              hover:bg-green-300/20 hover:border-green-300/70
              transition-all duration-200"
          >
            ← Ir al portfolio
          </Link>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium
              bg-gray-800/60 border border-gray-700/50 text-gray-300
              hover:bg-gray-700/60 hover:border-gray-600 hover:text-white
              transition-all duration-200"
          >
            Ver el blog
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}
